import React from 'react';
import { Chip } from '@mui/material';
import colors from 'src/utils/colors';

type Props = {
  keyProp: string;
  label: string;
  backgroundColor?: string;
  onDelete?: () => void;
};

export default function FilterChip({ keyProp, label, backgroundColor = colors.greenTagOpaque, onDelete }: Props) {
  return (
    <Chip
      key={keyProp}
      variant="outlined"
      label={label}
      size="small"
      onDelete={onDelete}
      sx={{
        backgroundColor,
        borderColor: colors.graysSecondary,
        fontSize: '12px',
        height: '24px',
        margin: '4px',
        display: 'flex',
        alignItems: 'center',
        '& .MuiChip-label': {
          paddingLeft: '12px',
          paddingRight: '12px',
          lineHeight: '1',
          display: 'flex',
          alignItems: 'center',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 400
        }
      }}
    />
  );
}
